import { useBreakpointListener } from '@zoopla/dom-util';
import { withErrorBoundary } from '@zoopla/shared/components';
import { useTheme } from '@emotion/react';
import { useLoggedInStatus } from '@zoopla/redux-reducer-user';
import { useEnrichedSavedPropertyIds } from './graphql/EnrichedSavedPropertyIds';
import { SavedListingsWidgetMobile } from './SavedListingsWidgetMobile/SavedListingsWidgetMobile';
import { SavedListingsWidgetDesktop } from './SavedListingsWidgetDesktop/SavedListingsWidgetDesktop';

export const LISTINGS_TO_DISPLAY_MOBILE = 3;
export const LISTINGS_TO_DISPLAY_DESKTOP = 4;

export const SavedListingsWidgetContainer = () => {
    const loggedInStatus = useLoggedInStatus();
    const isLoggedIn = loggedInStatus === 'isLoggedIn';

    const theme = useTheme();
    const isMobile = useBreakpointListener(theme.breakpoints[1], 'LT');

    const listingsCount = isMobile
        ? LISTINGS_TO_DISPLAY_MOBILE
        : LISTINGS_TO_DISPLAY_DESKTOP;

    const { savedListings } = useEnrichedSavedPropertyIds();

    const listingsToDisplay = savedListings?.slice(0, listingsCount) || [];

    if (!isLoggedIn || !listingsToDisplay.length) {
        return null;
    }

    return isMobile ? (
        <SavedListingsWidgetMobile listings={listingsToDisplay} />
    ) : (
        <SavedListingsWidgetDesktop listings={listingsToDisplay} />
    );
};

export default withErrorBoundary(SavedListingsWidgetContainer, null);
